/**
 * Get formated line value for swish
 * @param {import('./swish-match-stats-model').default & import('./swish-player-stats-model').default} item 
 * @returns {string} - formated line string
 */
export function getLineName(item) {
  const isSpread = item.showTeamName && item.showLine;
  if (isSpread) {
    return `(${item.line})`;
  }
  if (item.showLine || item.fullName) {
    return item.line;
  }
  return '';
}